export class GoogleWorkspaceSnapshotProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "userCount",
            "baseName": "userCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "suspendedCount",
            "baseName": "suspendedCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "deletedCount",
            "baseName": "deletedCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "sharedDriveCount",
            "baseName": "sharedDriveCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "skippedSharedDriveCount",
            "baseName": "skippedSharedDriveCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceSnapshotProperties.attributeTypeMap;
    }
    constructor() {
    }
}
